import React from 'react';
import EnhancedHeroSection from '../EnhancedHeroSection';
import AboutSection from '../AboutSection';
import AwardsSection from '../AwardsSection';
import Footer from '../Footer';

const Home = () => {
  return (
    <div className="App">
      <EnhancedHeroSection />
      <AboutSection />
      <AwardsSection />
      <Footer />
    </div>
  );
};

export default Home;




